export default __webpack_public_path__ + "static/media/computeIT.011e9f85.svg";